import styled from 'styled-components';
import { Table, Form } from 'antd';
import { mixin } from 'shared/utils/styles';

export const StyledTable = styled(Table)`
  ${mixin.backgroundTableEven}

  & .ant-table thead > tr > th {
    vertical-align: top;
    background-color: transparent;
  }

  & .table-header {
    &__search {
      padding-top: 6px;
    }
  }
`;

export const StyledFormItem = styled(Form.Item)`
  margin-bottom: 0px;
`;

export const ToolsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
